import React from "react";
import { Stack, TextField, Typography } from "@mui/material";
import HtmlEditor from "./HtmlEditor";

const normalizeArray = (a) => (Array.isArray(a) ? a : []);

const QuestionFormDnD = ({ value, onChange }) => {
    const v = value || {};
    const words = normalizeArray(v.initialWords);

    function setWord(idx, patch) {
        const next = words.map((w, i) => (i === idx ? { ...w, ...patch } : w));
        onChange({ ...v, initialWords: next });
    }

    function addWord() {
        onChange({
            ...v,
            initialWords: [...words, { id: Date.now(), text: "", type: "leftBucket" }],
        });
    }

    function removeWord(idx) {
        onChange({ ...v, initialWords: words.filter((_, i) => i !== idx) });
    }

    return (
        <Stack spacing={2}>
            <HtmlEditor
                label="Питання (HTML)"
                value={v.question || ""}
                onChange={(question) => onChange({ ...v, question })}
                helperText="Текст інструкції для старого DnD-завдання."
                minHeight={120}
            />

            <TextField
                label="Назва лівого кошика"
                value={v.leftBucketTitle || ""}
                onChange={(e) => onChange({ ...v, leftBucketTitle: e.target.value })}
                helperText="Показується над лівою зоною."
                fullWidth
            />

            <TextField
                label="Назва центрального кошика"
                value={v.centerBucketTitle || ""}
                onChange={(e) => onChange({ ...v, centerBucketTitle: e.target.value })}
                helperText="Використовується лише якщо кошиків більше ніж два."
                fullWidth
            />

            <TextField
                label="Назва правого кошика"
                value={v.rightBucketTitle || ""}
                onChange={(e) => onChange({ ...v, rightBucketTitle: e.target.value })}
                helperText="Показується над правою зоною."
                fullWidth
            />

            <TextField
                label="Кількість кошиків"
                type="number"
                value={v.bucketsAmount ?? 2}
                onChange={(e) => onChange({ ...v, bucketsAmount: Number(e.target.value) || 2 })}
                helperText="Старий DnD підтримує 2 або 3 кошики."
                fullWidth
            />

            <Typography variant="subtitle2">Слова</Typography>

            {words.map((w, idx) => (
                <Stack key={idx} direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <TextField
                        label="ID"
                        value={w.id ?? ""}
                        onChange={(e) => setWord(idx, { id: Number(e.target.value) || e.target.value })}
                        helperText="Службовий код слова."
                        sx={{ width: { sm: 140 } }}
                    />
                    <TextField
                        label="Слово"
                        value={w.text || ""}
                        onChange={(e) => setWord(idx, { text: e.target.value })}
                        helperText="Текст, який побачить учень."
                        fullWidth
                    />
                    <TextField
                        label="Правильний кошик"
                        value={w.type || "leftBucket"}
                        onChange={(e) => setWord(idx, { type: e.target.value })}
                        placeholder="leftBucket / centerBucket / rightBucket"
                        helperText="Службове значення: leftBucket, centerBucket або rightBucket."
                        sx={{ width: { sm: 220 } }}
                    />
                    <TextField
                        value="✕"
                        onClick={() => removeWord(idx)}
                        sx={{ width: { sm: 60 }, "& input": { cursor: "pointer", textAlign: "center" } }}
                        inputProps={{ readOnly: true }}
                    />
                </Stack>
            ))}

            <TextField
                value="+ додати слово"
                onClick={addWord}
                inputProps={{ readOnly: true }}
                sx={{ "& input": { cursor: "pointer" } }}
            />
        </Stack>
    );
};

export default QuestionFormDnD;
